/* Mrays — repair.html: brand → model picker.
   Picking a model navigates to repair-quote.html?brand=&model= to build
   the actual repair (separate page, like Cashify's own flow). */

(function () {
  'use strict';

  if (typeof MODELS_BY_BRAND === 'undefined') return;

  var brandButtons = Array.prototype.slice.call(document.querySelectorAll('.devicepicker__brand'));
  var gridEl = document.getElementById('dpGrid');
  var searchInput = document.getElementById('dpSearch');
  var quotePath = (gridEl && gridEl.dataset.quotePath) || '/pages/repair-quote';
  var selfPath = window.location.pathname;

  if (!brandButtons.length || !gridEl) return;

  // Shopify's CDN accepts a width= transform on any asset URL. modelPhoto()
  // now returns a URL that already carries the ?v= cache-busting hash, so this
  // has to append with & — joining with ? would drop the version and pin the
  // browser to a year-old cached copy of the photo.
  function cdnWidth(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  var params = new URLSearchParams(window.location.search);
  var currentBrand = params.get('brand') && MODELS_BY_BRAND[params.get('brand')] ? params.get('brand') : 'apple';
  var currentQuery = '';

  // The repair chosen back on the services rail, carried through so the quote
  // page can open with it already selected instead of asking twice.
  var ISSUE_LABELS = {
    screen: 'Screen', lcd: 'LCD screen', battery: 'Battery', charging: 'Charging jack',
    mic: 'Mic', receiver: 'Receiver', speaker: 'Speaker', backpanel: 'Back panel',
    proximity: 'Proximity sensor', auxjack: 'Aux jack', camera: 'Camera',
    board: 'Motherboard', liquid: 'Liquid damage', cleaning: 'Cleaning',
    software: 'Software & data'
  };
  var currentIssue = params.get('issue') && ISSUE_LABELS[params.get('issue')] ? params.get('issue') : '';

  var issueEl = document.getElementById('dpIssue');
  var issueNameEl = document.getElementById('dpIssueName');
  var issueClearEl = document.getElementById('dpIssueClear');

  function syncUrl() {
    var q = '?brand=' + encodeURIComponent(currentBrand);
    if (currentIssue) q += '&issue=' + encodeURIComponent(currentIssue);
    history.replaceState(null, '', selfPath + q);
  }

  function renderIssue() {
    if (!issueEl) return;
    if (currentIssue) {
      issueNameEl.textContent = ISSUE_LABELS[currentIssue];
      issueEl.hidden = false;
    } else {
      issueEl.hidden = true;
    }
  }

  // Called by the services rail when the picker is on the same page, so
  // choosing an issue doesn't cost a page load.
  window.mraysSetIssue = function (issue, label) {
    if (!issue || !ISSUE_LABELS[issue]) return;
    currentIssue = issue;
    renderIssue();
    renderGrid();
    syncUrl();
  };

  if (issueClearEl) {
    issueClearEl.addEventListener('click', function () {
      currentIssue = '';
      renderIssue();
      renderGrid();
      syncUrl();
    });
  }

  function renderGrid() {
    var models = MODELS_BY_BRAND[currentBrand] || [];
    var q = currentQuery.trim().toLowerCase();
    var filtered = q ? models.filter(function (m) { return m.toLowerCase().indexOf(q) !== -1; }) : models;

    if (!filtered.length) {
      gridEl.innerHTML = '<p class="devicepicker__empty">No model matches “' + currentQuery + '”.</p>';
      return;
    }

    gridEl.innerHTML = filtered.map(function (model) {
      var href = quotePath + '?brand=' + encodeURIComponent(currentBrand) + '&model=' + encodeURIComponent(model);
      if (currentIssue) href += '&issue=' + encodeURIComponent(currentIssue);
      var photo = modelPhoto(currentBrand, model);
      var srcset = cdnWidth(photo, 220) + ' 220w, ' + cdnWidth(photo, 440) + ' 440w';
      return (
        '<a class="devicepicker__card" role="listitem" href="' + href + '">' +
          '<img src="' + cdnWidth(photo, 220) + '" srcset="' + srcset + '" sizes="150px" alt="" loading="lazy" decoding="async" onerror="modelPhotoFallback(this, \'' + currentBrand + '\')">' +
          '<span>' + model + '</span>' +
        '</a>'
      );
    }).join('');
  }

  brandButtons.forEach(function (btn) {
    if (btn.dataset.brand === currentBrand) {
      brandButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', String(b === btn)); });
    }
    btn.addEventListener('click', function () {
      currentBrand = btn.dataset.brand;
      brandButtons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      searchInput.value = '';
      currentQuery = '';
      renderGrid();
      syncUrl();
    });
  });

  searchInput.addEventListener('input', function () {
    currentQuery = searchInput.value;
    renderGrid();
  });

  renderIssue();

  // The section server-renders the default brand's grid so the models are in
  // the HTML at first paint. Re-rendering identical markup here would throw
  // that away and restart the image decodes for nothing, so the first render
  // is skipped when what's already on the page is the brand we'd have drawn —
  // unless an issue is set, since the server-rendered links don't carry it.
  if (gridEl.dataset.ssrBrand === currentBrand && gridEl.firstElementChild && !currentIssue) {
    delete gridEl.dataset.ssrBrand;
  } else {
    renderGrid();
  }
})();
